import { BrowserRouter as Router } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { AppRoutes } from './routes';
import { ToastContainer } from './components/ui/ToastContainer';
import { LoadingProvider } from './context/LoadingContext';
import { PerformanceProvider } from './context/PerformanceContext';
import { useAuthErrorHandler } from './hooks/useAuthErrorHandler';
import { DataPreloader } from './components/data/DataPreloader';
import { CompanyProvider } from './context/CompanyContext';
import { QueryProvider } from './providers/QueryProvider';
import { ErrorBoundary } from './components/ErrorBoundary';

function AppContent() {
  // Gestionnaire global des erreurs d'authentification
  useAuthErrorHandler();
  
  return (
    <Layout>
      <DataPreloader />
      <AppRoutes />
      <ToastContainer />
    </Layout>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <QueryProvider>
        <Router>
          <PerformanceProvider>
            <LoadingProvider>
              <CompanyProvider>
                <AppContent />
              </CompanyProvider>
            </LoadingProvider>
          </PerformanceProvider>
        </Router>
      </QueryProvider>
    </ErrorBoundary>
  );
}

export default App;